import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function homePanel(panel: HTMLElement) : void {
  let mm = gsap.matchMedia()
  const image = panel.querySelector('.image') as HTMLElement

  mm.add('(min-width: 769px)', () => {
    ScrollTrigger.create({
      trigger: panel,
      start: 'top-=106 top',
      end: 'bottom bottom-=9999',
      pin: image,
      pinSpacing: false,
      anticipatePin: 1,
      markers: false
    })
  })
}
